<template>
  <div>
    师傅提醒设置
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>